import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/responsive-mac.css'; // Mac 1440x900 Optimization
import './styles/responsive-mobile.css'; // Mobile-specific Optimization
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import 'react-toastify/dist/ReactToastify.css';

// Suppress the benign ResizeObserver loop notification before CRA's overlay registers.
const _origOnerror = window.onerror;
window.onerror = function (msg) {
  if (typeof msg === 'string' && msg.includes('ResizeObserver loop')) return true;
  return _origOnerror ? _origOnerror.apply(this, arguments) : false;
};
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
  }
}, true);

TimeAgo.addDefaultLocale(en)


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    {/* <React.StrictMode> */}
    <App />
    {/* </React.StrictMode> */}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
